// import getKey from 'lodash/get';

import React from 'react';
import Admin from 'hive-admin';

import moment from 'moment-timezone';
import { LoadingOutlined } from '@ant-design/icons';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  EDIT as FIELDS_EDIT,
} from './fields';

// import tests from '../../helpers/tests';

export default [
  ['ADMIN', {
    path: '/customers',
  }],
  ['SELLER', {
    path: '/store/customers',
    loadUrl: '/sale-summaries',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
      forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_EDIT]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_EDIT]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Customers',
      // icon: 'usergroup-add',
      path: config.path,
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
          forRole === 'ADMIN'
          ? '/store/customers'
          : forRole === 'SELLER'
          ? '/customers'
          : null,
        ],
      ],
      archiveConfig: {
        titleColumnPath: 'customerDetails.name',
        renderHeaderDescription: () => {
          const now = moment();
          const endDate = moment('2024-04-16');
          const daysLeft = endDate.diff(now, 'days');
          const hoursLeft = endDate.diff(now, 'hours');
          let shouldUseHours = false;
          if (daysLeft < 1) {
            shouldUseHours = true;
          }
          if (hoursLeft < 1) {
            return null;
          }
          return (
            <span>
              <LoadingOutlined />
              {' '}
              Processing all customers for the previous year.
              Estimated time left:
              {' '}
              {shouldUseHours ? hoursLeft : daysLeft}
              {' '}
              {shouldUseHours ? 'hours.' : 'days.'}
            </span>
          );
        },
        loadUrl: '/sale-summaries',
        createButtonSupported: false,
        // icon: 'usergroup-add',
        title: 'Customers',
        label: 'Customers',
        filters: FILTERS,
        columns: COLUMNS,
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
      },
      // eslint-disable-next-line max-len
      singleLoadUrl: '/sale-summaries/:id/?populateOrders=true&populateStore=true',
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        headerTitle: 'Customer',
        headerTitleKey: 'customerDetails.name',
      },
      singleEditConfig: {
        actions: [],
      },
      fields: FIELDS,
    }])
    .pages);
    return pages;
  },
  [],
);
